import styled, { css } from "styled-components"

const StyledContainer = styled.div`
  width: ${ props => props.width }%;

  ${ props => props.mobile && css`
    @media ${props => props.theme.mobileDown} {
      width: ${ props => props.mobile }%;
    }
  `}
`

// const ScaledSvg = (props) => {
//   return (
//     <StyledContainer width={props.width}>
//     {props.children}
//     </StyledContainer>
//   )
// }

export default StyledContainer